<template lang="pug">
.rating-number(:class="classType")
  .rating-number__count {{ number }}
</template>

<script>
export default {
  name: "RatingNumber",
  props: {
    type: {
      type: String,
      default: "bronze",
    },
    number: {
      type: Number,
      default: 10,
    },
  },
  computed: {
    classType() {
      return `rating-number--${this.type}`;
    },
  },
};
</script>
